import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable jsx-a11y/label-has-associated-control */
import { ErrorMessage } from "@components/atoms";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import uploadIcon from "../../../../images/upload.svg";
import * as S from "./styles";
export var InputFile = function InputFile(_ref) {
  var errors = _ref.errors,
      helpText = _ref.helpText,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple,
      label = _ref.label,
      _onChange = _ref.onChange,
      onClear = _ref.onClear,
      rest = _objectWithoutProperties(_ref, ["errors", "helpText", "multiple", "label", "onChange", "onClear"]);

  // const hasErrors = !!(errors && errors.length);
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      files = _useState2[0],
      setFiles = _useState2[1];

  var intl = useIntl();

  function handleClear() {
    setFiles(null);

    if (onClear) {
      onClear();
    }
  }

  return React.createElement(React.Fragment, null, React.createElement(S.TextField, null, React.createElement(S.InputWrapper, null, React.createElement(S.Label, null, React.createElement("input", {
    type: "file",
    onChange: function onChange(e) {
      var list = e.target.files;
      setFiles(list);

      if (!list || !list.length) {
        handleClear();
      }

      if (_onChange) {
        _onChange(e);
      }
    },
    multiple: multiple,
    accept: "image/*"
  }), React.createElement("span", null, files ? "".concat(files.length, " ").concat(intl.formatMessage(_defineProperty({
    defaultMessage: "file(s) selected",
    "id": "@next.components.molecules.InputFile.InputFile.3937451399"
  }, "id", "@next.components.molecules.InputFile.InputFile.3937451399"))) : label || intl.formatMessage(_defineProperty({
    defaultMessage: "Select file",
    "id": "@next.components.molecules.InputFile.InputFile.2755046195"
  }, "id", "@next.components.molecules.InputFile.InputFile.2755046195"))), React.createElement("img", {
    src: uploadIcon,
    alt: "upload"
  })), files && files.length && React.createElement("button", {
    className: "cancel",
    type: "button",
    onClick: function onClick() {
      return handleClear();
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "clear files",
    "id": "@next.components.molecules.InputFile.InputFile.3600593504"
  }, "id", "@next.components.molecules.InputFile.InputFile.3600593504")))), React.createElement(S.ErrorMessages, null, React.createElement(ErrorMessage, {
    errors: errors
  }), helpText && React.createElement(S.HelpText, null, helpText))));
};